import React, { useState, useEffect } from 'react';
import { Card, Button, Form,Toast } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SideDrawer from '../components/SideDrawer';
import '../styles/Profile.css';
import { changePassword } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import userAvtar from '../assets/icons/Avatar.png';
import MainLayout from './MainLayout';
import EditSvg from '../assets/icons/Edit_24px.svg';
import ProfileImg from '../assets/icons/User_24px.svg'
import UnHideImg from '../assets/icons/UnHide_24px.svg'
import HideImg from '../assets/icons/Hide_24px.svg'
import LockImg from '../assets/icons/Lock_24px.svg'
import SuccessImg from '../assets/icons/Success.svg'

export default function Profile() {
  const navigate = useNavigate();
  const { username: contextUsername, email: contextEmail, isCollapsed, userRole } = useAuth(); // Get username and email from context
  const [username, setUsername] = useState(contextUsername);
  const [email, setEmail] = useState(contextEmail);
  const [newPassword, setNewPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('password');
  const [showNotification, setShowNotification] = useState(false);
  const [message, setMessage] = useState('');
  const [toastType, setToastType] = useState('success');
    // Individual password visibility states
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
  useEffect(() => {
    // Update state when context changes
    setUsername(contextUsername);
    setEmail(contextEmail);
  }, [contextUsername, contextEmail]);

  const handleBack = () => {
    navigate('/dashboard');
  };

  const handlePasswordChange = async (event) => {
    event.preventDefault();
    if (newPassword === confirmPassword) {
      try {
        const response = await changePassword(oldPassword, confirmPassword);
        setMessage(response.data.message);
        setToastType('success')
        setShowNotification(true);
        setNewPassword('');
        setConfirmPassword('');
        setOldPassword('');
      } catch (error) {
        console.error('Error changing password:', error);
        setMessage('Error changing password');
        setToastType('error')
        setShowNotification(true);
      }
    } else {
      setMessage("Passwords do not match!");
      setToastType('error')
      setShowNotification(true);
    }
  };

  const handleUsernameChange = (event) => {
    event.preventDefault();
    // Logic to update the username goes here
    console.log('Username updated to:', username);
    setMessage("Username updated successfully");
    setToastType('success');
    setShowNotification(true);
  };
  const handleEditBtnClick = (value) => {
    setActiveTab(value);
    setIsFormOpen(true);
  }

  return (
    // <div className="App container-fluid">
    //   <SideDrawer />
    //   <div className="main-container d-flex flex-column" style={{ marginLeft: isCollapsed ? '6%' : '13.6%' }}> 
    //     <div className="col">
    //       <Button variant="link" onClick={handleBack} className="mt-4">
    //         <span>&larr;</span> Back to Home
    //       </Button>
    <MainLayout>
      <div className={`min-h-screen d-flex gap-4 align-items-center my-5 ${!isFormOpen ? ' justify-content-center ' : 'justify-content-start '}`}>
        <Card className={`profile-card border rounded-6 ${!isFormOpen ? ' w-100' : 'form-open'}`}>
          <Card.Body>
            <h2 className="mb-4 title">My Profile</h2>
            {!isFormOpen && (
              <>
                <div className="border rounded-6 px-3 py-4 d-flex flex-wrap align-items-center user-profile my-3 gap-3">
                  <div className='d-flex align-items-center justify-content-center flex-wrap user-profile-content'>
                    <img src={userAvtar}
                      alt="User Avatar" className="" width={'120px'} height={'120px'} />
                    <div className='user-details'>

                      <p className="user-name">{username}</p>
                      <p className='user-role-email d-flex flex-wrap justify-content-center align-items-center'><p className='m-0'>{userRole} </p><div className='dot'></div> <p className='m-0'>{email}</p></p>
                    </div>
                  </div>
                  <button className='edit-btn handle-btns' onClick={() => handleEditBtnClick('username')}>Edit <img src={EditSvg} alt="Edit" className='ms-2' style={{ width: '24px', height: '24px' }} /></button>
                </div>
                <div className="d-flex flex-wrap w-100 align-items-center user-password border rounded-7 px-3 py-4 my-3">
                  <div className='d-flex flex-column password-header'>
                    <p className="heading-title m-0">Password</p>
                    <p className='sub-heading-line'>Your Password has been change</p>
                  </div>
                  <button className="edit-btn handle-btns px-4 py-2" onClick={() => handleEditBtnClick('password')}>Change Password <img src={EditSvg} alt="Edit" className='ms-2' style={{ width: '24px', height: '24px' }} />
                  </button>
                </div>
              </>

            )}
            {isFormOpen && (
              <>
                {activeTab === 'password' ? (
                  <Form className='px-3 my-2 border rounded-6 form-container' onSubmit={handlePasswordChange}>
                    <Form.Group controlId="formOldPassword" className='mb-2 mt-3'>
                      <Form.Label className='m-0 sub-heading-title'>Old Password</Form.Label>
                      <div className='d-flex align-items-center social-icon-input-width'>
                        <img src={LockImg} alt="Old Password" width={24} height={24} />
                        <input
                          type={showOld ? 'text' : 'password'}
                          required
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                          className="form-control inline-input"
                          placeholder='Enter your old password'
                        />
                        <img src={showOld ? UnHideImg : HideImg}
                          alt={showOld ? "Hide password" : "Show password"} width={24} height={24} onClick={()=>setShowOld(!showOld)} />
                      </div>
                    </Form.Group>

                    <Form.Group controlId="formNewPassword" className='mb-2 mt-3'>
                      <Form.Label className='m-0 sub-heading-title'>New Password</Form.Label>
                      <div className='d-flex align-items-center social-icon-input-width'>
                        <img src={LockImg} alt="New Password" width={24} height={24} />
                        <input
                          type={showNew? 'text' : 'password'}
                          required
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="form-control inline-input"
                          placeholder='Enter your new password'
                        />
                        <img src={showNew ? UnHideImg : HideImg}
                          alt={showNew ? "Hide password" : "Show password"} width={24} height={24} onClick={()=>setShowNew(!showNew)} />
                      </div>
                    </Form.Group>

                    <Form.Group controlId="formConfirmPassword" className='mb-2 mt-3'>
                      <Form.Label className='m-0 sub-heading-title'>Confirm Password</Form.Label>
                      <div className='d-flex align-items-center social-icon-input-width'>
                        <img src={LockImg} alt="Confirm Password" width={24} height={24} />
                        <input
                          type={showConfirm ? 'text' : 'password'}
                          required
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="form-control inline-input"
                          placeholder='Confirm your new password'
                        />
                        <img src={showConfirm ? UnHideImg : HideImg}
                          alt={showConfirm ? "Hide password" : "Show password"} width={24} height={24} onClick={()=>setShowConfirm(!showConfirm)} />
                      </div>
                    </Form.Group>

                    <div className='d-flex save-cancel-btn align-items-center'>
                      <button onClick={() => setIsFormOpen(false)} className='cancel-btn'>Cancel</button>
                      <button type="submit" className="save-btn my-4">Save Changes</button>
                    </div>
                  </Form>

                ) : (
                  <Form className='px-3 my-2 border rounded-6 form-container' onSubmit={handleUsernameChange}>
                    <Form.Group controlId="formBasicUsername" className='mb-2 mt-3'>
                      <Form.Label className='m-0 sub-heading-title'>Username</Form.Label>
                      <div className='d-flex align-items-center social-icon-input-width' >
                        <img src={ProfileImg} alt="Instagram" className='' width={24} height={24} />
                        <input
                          type="text"
                          required
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          className="form-control inline-input"
                        />
                      </div>
                    </Form.Group>
                    <Form.Group controlId="formBasicUsername" className='mb-2 mt-3'>
                      <Form.Label className='m-0 sub-heading-title'>Email</Form.Label>
                      <div className='d-flex align-items-center social-icon-input-width' style={{ backgroundColor: '#E9EAEB' }}>
                        <img src={ProfileImg} alt="Instagram" className='' width={24} height={24} />
                        <input
                          type="text"
                          required
                          value={email}
                          className="form-control inline-input"
                          disabled
                          style={{ backgroundColor: '#E9EAEB' }}
                        />
                      </div>
                    </Form.Group>
                    <div className='d-flex save-cancel-btn align-items-center'>
                      <button onClick={() => setIsFormOpen(false)} className='cancel-btn'>Cancel</button>
                      <button type="submit" className="save-btn my-4">
                        Save Changes
                      </button>
                    </div>
                  </Form>
                )}
              </>
            )}
          </Card.Body>
        </Card>
        <Toast show={showNotification} onClose={() => setShowNotification(false)} className='custom-toast' style={{backgroundColor:`${toastType === 'success'? '#E0F8E6': '#fdecea'}`, border:`${toastType === 'success'? '1px solid #2AA14C': '1px solid rgb(241 33 8)'}` }} delay={3000} autohide>
            <Toast.Body className='text-dark'><img src={SuccessImg} alt='img' className='mx-2'/> {message}</Toast.Body>
        </Toast>
      </div>
      
    </MainLayout>
    //     </div>
    //   </div>
    // </div>
  );
}
